import { RiCodeView, RiPresentationFill, RiQuillPenLine } from '@remixicon/react'
import React from 'react'
import SlideUp from '../../utlits/animations/slideUp'

const ServiceGrid = () => {
    return (
        <section id="services" className="services-area innerpage-single-area">
            <div className="container">
                <div className="container-inner">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12">
                            <SlideUp>
                                <div className="section-title text-center">
                                    <p>Services</p>
                                    <h2>¿Qué servicios ofrezco?</h2>
                                </div>
                            </SlideUp>
                        </div>
                    </div>
                    <div className="row">
                        <Card id={1} icon={<RiCodeView size={60} />} title={"Desarrollo"} description={"Desarrollo rápido y eficaz de aquello que necesites. ¿Web, aplicación móvil, sistema de gestión? ¡Déjamelo a mí!"} />
                        <Card id={2} icon={<RiPresentationFill size={60} />} title={"Publicidad"} description={"La misión del marketing es dar a conocer tu marca, y es algo que me encanta. ¿Enseñamos al mundo lo que haces? :)"} />
                        <Card id={3} icon={<RiQuillPenLine size={60} />} title={"Diseño"} description={"Mi experiencia como diseñador y maquetador da garantías de realización de gráficos de calidad y UX/UI."} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ServiceGrid

const Card = ({ icon, title, description, id }) => {
    return (
        <div className="col-lg-4 col-md-6">
            <SlideUp delay={id}>
                <div className="service-item">
                    {icon}
                    <h4>{title}</h4>
                    <p>{description}</p>
                </div>
            </SlideUp>
        </div>
    )
}